import * as ko from 'knockout';
import * as _ from 'underscore';
import * as koMapping from 'knockout.mapping';
import * as configurationService from 'configurationService';
import * as windowHelper from 'windowHelper';
import * as cookieHelper from 'cookieHelper';
import * as globalConfig from 'globalConfig';
import 'selectTwoBindingConfig';
import 'knockoutCustomBindings';

import { LanguageService } from 'Content/ts/Shared/Language/Services/languageService';
import { Language } from 'Content/ts/Models/Shared/Language/Language';

export const Deps = {
    languageService: new LanguageService(),
    configurationService: configurationService,
    windowHelper: windowHelper,
    cookieHelper: cookieHelper,
    globalConfig: globalConfig
}

const BrowserLanguageToggleSetting = "BrowserLanguageToggle";
const BrowserLanguageToggleCookie = "LanguageToggle";

export class LanguageSelector {
    enabled: KnockoutObservable<boolean>;
    loading: KnockoutObservable<boolean>;
    languages: KnockoutObservableArray<Language>;
    currentLanguage: KnockoutObservable<Language>;
    selectedLanguageId: KnockoutObservable<number>;
    selecting: KnockoutObservable<boolean>;

    constructor() {
        this.enabled = ko.observable(false);
        this.loading = ko.observable(false);
        this.languages = ko.observableArray([]);
        this.selecting = ko.observable(false);
        this.currentLanguage = ko.observable(Deps.globalConfig.CurrentLanguage);
        this.selectedLanguageId = ko.observable(Deps.globalConfig.CurrentLanguage.Id);

        this.getEnabled();

        this.setupSubscribes();
    }

    private setupSubscribes() {
        this.selectedLanguageId.subscribe((value) => {
            if (value !== undefined && value !== this.currentLanguage().Id) {
                this.setLanguage(value);
            }
        });
    };

    private extraLanguageMappings = {
        create: ((lang: any) => {
            lang.data.id = lang.data.Id;
            lang.data.text = lang.data.NativeName;
            lang.data.Value = lang.data.Id;

            if (lang.data.Id === this.selectedLanguageId()) {
                lang.data.selected = true;
            }

            return lang.data;
        })
    };

    getEnabled() {
        var cookie = Deps.cookieHelper.getCookieValue(BrowserLanguageToggleCookie);

        if (cookie) {
            var result = $.parseJSON(cookie);
            if (typeof result === 'boolean') {
                this.enabled(result);
            }
        } else {
            Deps.configurationService.getConfigurationSetting(BrowserLanguageToggleSetting).then((config) => {
                var configResult = Deps.configurationService.getTruthy(config.SettingValue);
                this.enabled(configResult);
                Deps.cookieHelper.createOrUpdateCookie(BrowserLanguageToggleCookie, configResult.toString(), { expires: 1, path: '/', secure: true });
            });
        }
    }

    getLanguages() {
        this.loading(true);

        return Deps.languageService.getLanguages().then((langs: any) => {
            koMapping.fromJS(langs, (<any>this.extraLanguageMappings), this.languages);
        }).finally(() => this.loading(false));
    }

    setLanguage(languageId: number) {
        this.loading(true);

        Deps.languageService.setLanguage(languageId)
            .then(() => { Deps.windowHelper.refresh(); })
            .catch(() => { this.loading(false); });
    }

    changeLanguage() {
        return this.getLanguages().then(() => { this.selecting(true); });
    }
}

const componentName = 'language-selector';
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: LanguageSelector,
    template: { require: `text!Content/ts/Shared/Language/${componentName}.html` }
});